<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" variant="primary" sticky>
      <b-nav-toggle target="nav_collapse"></b-nav-toggle>

      <b-navbar-brand href="#/">ASM80 Tools</b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item-dropdown text="Conversions" right>
            <b-dropdown-item href="#/lst2asm">LST to ASM</b-dropdown-item>
            <b-dropdown-item href="#/bin2asm">BIN to ASM, JS</b-dropdown-item>
            <b-dropdown-item href="#/hex2asm">HEX to ASM, JS</b-dropdown-item>
            <b-dropdown-item href="#/hex2bin">HEX to BIN</b-dropdown-item>
            <b-dropdown-item href="#/bitswap">Bit order swapper</b-dropdown-item>
            <b-dropdown-item href="#/sna2bas">ZXS: SNA to BASIC</b-dropdown-item>
            <b-dropdown-item href="#/i2z">I8080 ASM to Z80</b-dropdown-item>
            <b-dropdown-item href="#/z2i">Z80 ASM to I8080</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Generators" right>
            <b-dropdown-item href="#/math">Math table</b-dropdown-item>
            <b-dropdown-item href="#/sound">Sound dividers</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="https://www.asm80.com">ASM80</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- navbar-1.vue -->

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
.sourceout {
  font-family: monospace;
  white-space: pre;
  overflow-y:scroll;
  max-height:300px;
}
</style>
